import React from "react";
import "./App.css";
import YunIcon from "../Common/YunIcon/YunIcon";
import YunHeader from "../Common/YunHeader/YunHeader";
import YunPlayer from "../Common/YunPlayer/YunPlayer";
import YunFooter from "../Common/YunFooter/YunFooter";

import YunEmFineTune from "../Common/YunEmFineTune/YunEmFineTune";
import YunEmList from "../Common/YunEmList/YunEmList";
import YunSharpFlat from "../Common/YunSharpFlat/YunSharpFlat";
import RemoveVocals from "../Common/RemoveVocals/RemoveVocals";
import SwitchAccHelper from "../Common/SwitchAccHelper/SwitchAccHelper";
import AccHelper from "../Common/AccHelper/AccHelper";
import YunEmSharpFlat from "../Common/YunEmSharpFlat/YunEmSharpFlat";
import MsgBox from "../Common/MsgBox/MsgBox";
import PluginTipDia from '../Common/PluginTipDia/PluginTipDia';

import { initEmList, isNoEm, openWindow, debounce } from "../../utils/index";

import { initEmConfig, initProduct, getLocalCnfJSON } from "./init";
import {
    setUpdateKeynote,
    setUpdateTune,
    updateRemoveVocals,
    getPlayerProcessName,
    getAiEmByIndex,
    getRandomEm,
    setUpdateEmValues,
    filterTargetEmValue,
    trimFirstAndLastSpace,
    findIndexInEmusics,
    compareEmAndPlayerdata,
    isScrollingTitle,
} from "./tools";

import { getPresetConfig, getShortcutList } from "../Common/YunEmFineTune/tool";

import {
    getPageset,
    setPageset,
    getSharpflatModel,
    getVocalsModel,
    getIsTop,
    setIsTop,
    getIsAiFirst,
    setIsAiFirst,
    getEmShortcut,
    getShortcutLink,
    getIsSetShortcutByEmModel,
    getEmModelShortcut,
    getEmValueModel,
    getEmModelNames,
    getEmTexts,
    getPlayerCaps,
    getPlayerCap,
    getDefaultEmValue,
    setDefaultEmValue,
    getEmPluginModel,
    setEmPluginModel,
    getRatePre,
    getHumanizePre,
    getVibratoPre,
    getFlexPre,
    getTrackingPre,
    setRatePre,
    setHumanizePre,
    setVibratoPre,
    setFlexPre,
    setTrackingPre,
    setEmShortcut,
    setShortcutLink,
    setEmLinkage,
    setIsSetShortcutByEmModel,
    getEmLinkage,
    getIsSetEnableAudioFFT,
    setIsSetEnableAudioFFT,
    getLocalAccModel,
    setLocalAccModel,
} from "./local";

import {
    DefaultPageset,
    UiExtConf,
    DefautlShortcut,
    DefaultShortcutLink,
    DefaultEmModelShortcut,
    Rate,
    Humanize,
    Vibrato,
    Flex,
    Tracking,
    EmLinkage,
} from "./data";

import { searchEm, getVipCheck, getPromotion, restrictedJudge, uploadKeynote, getUiExtConf } from "../../api/em";
import {
    cppSetToMainWindow,
    cppBroadcastWndMsg,
    cppStartRecordDeviceByProcessName,
    cppResetEmusicKeynote,
    cppStartRecordDevice,
    cppEnableAudioFFT,
    cppUpdateKeynote,
} from "../../api/cpp";

import { defaultProductInfo } from "../../static/getProductInfo";

import { loginState, getToken } from "../../utils/auth";
import { wafCaptchaManager } from "../../utils/wafCaptchaManager";

import {
    initLocalDb,
    updateLocalDbEm,
    // removeEmFromLocalDb,
    closeDb,
    updateLocalDbTune,
    updateLocalDbVocals,
    getMusicInfoFromLoadlDb,
    updateAiFirst,
    updateLocalDbAiEm,
} from "../../utils/dbHandle";

const d_setUpdateKeynote = debounce(setUpdateKeynote, 500);
const d_setUpdateTune = debounce(setUpdateTune, 200);
const d_updateRemoveVocals = debounce(updateRemoveVocals, 200);
const d_setDefaultEmValue = debounce(setDefaultEmValue, 500);

class App extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            isEnableAutotune: true,
            emList: {},
            playerData: {
                musicName: "",
                musicAuthor: "",
                player: "",
            },
            curSpk: "",
            lastPlayer: "",
            vipInfo: {
                isExpire: true,
                userPhone: "***********",
            },
            // 账号被封禁：整块界面盖住
            banned: false,
            // 有没有拿到过 vipcheck 的结果（没拿到之前不要按「已过期」渲染，会闪一下）
            vipChecked: false,
            currentKeynote: {},
            productInfo: defaultProductInfo,
            emSharpFlatState: {
                value: 0,
            },
            sharpFlatState: {
                value: 0,
                isSwitch: true,
                name: "升降调",
                online: false,
                pluginAry: [],
            },
            vocalsValue: 50,
            emPluginState: [],
            vocalsPluginState: [],
            promoteUrl: "",
            // 是否展开自定义基调设置
            isShowEmSet: false,
            // 本地数据库是否初始化
            isInitLocalDb: false,
            // 电音参数配置
            emPlugsV3: null,
            // 升降调模式和消人声 三种模式自动重置：reset、自动恢复：renew、锁定状态：lock
            sharpFlatModel: getSharpflatModel(),
            vocalsModel: getVocalsModel(),
            emValueModel: getEmValueModel(),
            // keynoteModel: "ai",
            isTop: getIsTop(new UiExtConf()),
            // 页面模块配置
            pageset: getPageset(new DefaultPageset(), new UiExtConf()),
            // 是否AI基调优先
            isAiFirst: getIsAiFirst(),
            // 是否自动选择的AI基调
            isAutoAiFirst: false,
            // Ai分析的电音基调
            aiEmData: null,
            currentAiEm: null,
            // 电音参数
            emValue: {
                rate: 0,
                humanize: 0,
                flex: 0,
                vibrato: 0,
                tracking: 0,
            },
            // 插件模式
            pluginModel: getEmPluginModel(),
            // 电音预配置参数
            presetConfig: {
                ratePreset: [],
                humanizePreset: [],
                flexPreset: [],
                vibratoPreset: [],
                trackingPreset: [],
                strengthPreset: [],
            },
            shortcut: new DefautlShortcut(),
            shortcutLink: new DefaultShortcutLink(),
            emModelShortcut: new DefaultEmModelShortcut(),
            isSetShortcutByEmModel: false,
            shortcutList: [],
            currentShortcutName: "",
            msgBoxOption: {
                show: false,
                msg: "",
            },
            // 联动调节
            emLinkage: new EmLinkage(),
            // 电音模式名称（后台可配）
            emModelNames: {
                soprano: '男/女高音',
                alto: '男/女中音',
                lowMale: '男/女低音',
            },
            // 界面文案（后台可配）
            emTexts: {
                subTitle: '其他可尝试的基调',
                subTip: '请选择适合自己的',
                aiEmptyTitle: 'AI分析未采集到音频信号',
                aiEmptyTip: '请选择正在使用的播放器',
            },
            // 播放器能力表（后台可配）：决定升降调/消人声显示控件、提示还是「切换伴奏助手」
            playerCaps: {},
            showmenu: false,
            pluginTipDiaState: {
                isVisibale: false,
                pluginName: "升降调"
            },
            // 伴奏模式
            AccModel: getLocalAccModel(),
            AccHelperValue: "0",
            // 是否使用SMTC媒体信息
            isSMTC: false,
            // 轻提示
            toastMsg: '',
        };
        this.reBackupListCount = 5;
        this.defaultKeynote = {};
        this.localDbEm = null;
        this.localDbAiEm = null;
        this.localAiFirst = null;
        this.aiEmCount = 0;
        // 是否选择AI基调
        this.isCheckedAiEm = false;
        // 存储AI基调的计时器
        this.aiEmTimer = null;
        // 存储上一次SMTC的title信息，用于检测滚动消息
        this.lastSmtcTitle = "";

        this.setEnableAutotune = this.setEnableAutotune.bind(this);
        this.setCurrentKeyNote = this.setCurrentKeyNote.bind(this);
        this.getEmInfo = this.getEmInfo.bind(this);
        this.getVipInfo = this.getVipInfo.bind(this);
        this.openPromotions = this.openPromotions.bind(this);
        this.setCurrentPlayer = this.setCurrentPlayer.bind(this);
        this.setSharpFlatState = this.setSharpFlatState.bind(this);
        this.setEmByLocalDb = this.setEmByLocalDb.bind(this);
        this.handleShowEmSet = this.handleShowEmSet.bind(this);
        this.setEmSharpFlatState = this.setEmSharpFlatState.bind(this);
        this.handlePageset = this.handlePageset.bind(this);
        this.handleEmErrInfo = this.handleEmErrInfo.bind(this);
        this.setSharpFlatValue = this.setSharpFlatValue.bind(this);
        this.updateSharpFlatValue = this.updateSharpFlatValue.bind(this);
        this.updateVocalsValue = this.updateVocalsValue.bind(this);
        this.updateKeyNoteByTune = this.updateKeyNoteByTune.bind(this);
        this.handleSetIsTop = this.handleSetIsTop.bind(this);
        this.reloadLocalCnf = this.reloadLocalCnf.bind(this);
        this.restoreServerDefaults = this.restoreServerDefaults.bind(this);
        this.setCurrentAiEm = this.setCurrentAiEm.bind(this);
        this.setAiEmFirst = this.setAiEmFirst.bind(this);
        this.setIsCheckedAiEm = this.setIsCheckedAiEm.bind(this);
        this.createRandomEm = this.createRandomEm.bind(this);
        this.setEmValue = this.setEmValue.bind(this);
        this.setPluginModel = this.setPluginModel.bind(this);
        this.setCurrentShortcutName = this.setCurrentShortcutName.bind(this);
        this.handleToLogin = this.handleToLogin.bind(this);
        this.openHottop = this.openHottop.bind(this);
        this.setCurSpk = this.setCurSpk.bind(this);
        this.clearAiEm = this.clearAiEm.bind(this);
        this.setshowmenu = this.setshowmenu.bind(this);
        this.setPluginTipDiaState = this.setPluginTipDiaState.bind(this);
        this.setAccModel = this.setAccModel.bind(this);
        this.switchToAccHelper = this.switchToAccHelper.bind(this);
        this.setIsSMTC = this.setIsSMTC.bind(this);
        this.accHelperSetSharpFlat = this.accHelperSetSharpFlat.bind(this);
        this.initRestrictedJudge = this.initRestrictedJudge.bind(this);
    }

    // 加载本地基调
    setEmByLocalDb(localEm, localAiEm, emusics) {
        // console.log(emusics);
        if (Array.isArray(emusics) && emusics.length) {
            // 设置默认基调
            this.defaultKeynote = emusics[0];
        } else {
            this.defaultKeynote = {};
        }
        let isShowEmSet = false;
        let isCheckedAiEm = false;
        const localType = localEm ? "EM_KN_ZX" : "EM_KN_AI_LOCAL";
        localEm = localEm || localAiEm;
        console.log("localEm=====", localEm);
        if (localEm && typeof localEm === "string") {
            const em = localEm.split(" ");
            const index = findIndexInEmusics(em, emusics);
            // if (Array.isArray(emusics) && emusics.length && emusics[0].newKeyNote === em[0] && emusics[0].newScale === em[1]) {
            if (index !== -1) {
                this.setCurrentKeyNote(emusics[index], true);
            } else {
                this.setCurrentKeyNote(
                    {
                        newKeyNote: em[0],
                        newScale: em[1],
                        type: localType,
                    },
                    true
                );
                // 本地基调不在云端列表内 弹出自定义基调选择弹框
                isShowEmSet = true;
            }
        } else {
            this.setCurrentKeyNote(this.defaultKeynote, true);
            if (
                !this.localAiFirst &&
                this.defaultKeynote.newKeyNote &&
                this.defaultKeynote.newScale &&
                compareEmAndPlayerdata(
                    this.defaultKeynote,
                    this.state.playerData
                )
            ) {
                isCheckedAiEm = this.state.isAiFirst;
            } else {
                isCheckedAiEm = true;
            }
        }
        this.setState({
            isShowEmSet: isShowEmSet,
            isAutoAiFirst: isCheckedAiEm,
        });
        this.isCheckedAiEm = isCheckedAiEm;
    }
    // 设置基调
    setCurrentKeyNote(em, isDefaultEm) {
        this.setState({
            currentKeynote: em,
        });
        d_setUpdateKeynote(
            em,
            this.state.sharpFlatState.value,
            this.state.emSharpFlatState.value,
            this.state.isEnableAutotune,
            this.state.emPlugsV3
        );
        // 设置新的基调前先阻止上一个要存储的基调
        if (this.aiEmTimer) {
            clearTimeout(this.aiEmTimer);
        }
        if (this.keynoteReportTimer) {
            clearInterval(this.keynoteReportTimer);
        }
        if (this.vipHeartbeatTimer) {
            clearInterval(this.vipHeartbeatTimer);
        }
        // AI基调缓存到单独的字段 使用超过一定时间才会存入数据库
        if (em && em.type === "EM_KN_AI") {
            const playerData = JSON.parse(
                JSON.stringify(this.state.playerData)
            );
            this.aiEmTimer = setTimeout(() => {
                updateLocalDbAiEm(em, playerData);
            }, 1000 * 60);
            return;
        }
        // if (!isDefaultEm && this.state.isInitLocalDb) {
        //     // 如果是自定义选择的没有id的基调  或者是选择的基调和根据偏好模式选择的基调不同 就存入本地
        //     if (!em.id || em.id !== this.defaultKeynote.id) {
        //         updateLocalDbEm(em, this.state.playerData);
        //     }
        //     // 如果设置的基调和选择基调相同  就从本地数据库删除
        //     if (this.defaultKeynote.id && em.id === this.defaultKeynote.id) {
        //         removeEmFromLocalDb(this.state.playerData);
        //     }
        // }
        if (!isDefaultEm && this.state.isInitLocalDb) {
            console.log("存储基调======", em.id)
            // 逻辑修改  只要是用户选择的基调  就存入本地数据库  不管是否和默认基调相同
            updateLocalDbEm(em, this.state.playerData);
        }
    }
    // 设置升降调状态
    setSharpFlatState(obj) {
        const newState = Object.assign({}, this.state.sharpFlatState, obj);
        this.setState({
            sharpFlatState: newState,
        });
    }
    // 每 30 秒检查一次：当前是 AI 基调且有在播歌曲 → 回传（同一首歌同一基调 5 分钟内不重复）
    tickReportAiKeynote() {
        // 封禁用户不跑 AI 分析（分析是本地算的，只能在这里拦）
        if (this.state.banned) {
            return;
        }
        const playerData = this.state.playerData || {};
        const cur = this.state.currentKeynote || {};
        if (!playerData.musicName || !cur.newKeyNote) {
            return;
        }
        if (String(cur.type || '').indexOf('AI') === -1) {
            return;
        }
        const key = playerData.musicName + '|' + cur.newKeyNote + '|' + cur.newScale;
        const last = this.lastKeynoteReport || { key: '', at: 0 };
        if (last.key === key && Date.now() - last.at < 5 * 60 * 1000) {
            return;
        }
        this.lastKeynoteReport = { key: key, at: Date.now() };
        this.reportKeynote(cur, 'AI');
    }
    // 轻提示
    showToast(msg) {
        // 结果直接在基调面板内显示，这里只打日志
        console.log('[toast]', msg);
    }
    // 回传基调（source: 'AI' / '手动'）
    reportKeynote(em, source) {
        if (this.state.banned) {
            return;
        }
        const playerData = this.state.playerData || {};
        const musicName = (em && em.musicName) || playerData.musicName;
        const musicAuthor = (em && em.musicAuthor) || playerData.musicAuthor;
        if (!musicName || !em || !em.newKeyNote) {
            return;
        }
        this.showToast(source === '手动' ? '正在提交…' : '正在回传 AI 基调…');
        return uploadKeynote({
            musicName: musicName,
            musicAuthor: musicAuthor || '',
            newKeyNote: em.newKeyNote,
            newScale: em.newScale || '大调',
            source: source || '手动'
        }).then(res => {
            console.log('基调回传：', source, musicName, em.newKeyNote, em.newScale, res && res.reason, res && res.votes);
            if (!res || res.err !== 'ERR_OK') {
                window.__keynoteReportResult = { msg: '提交失败：' + ((res && res.errMsg) || '网络错误'), at: Date.now() };
                this.showToast('提交失败：' + ((res && res.errMsg) || '网络错误'));
                return;
            }
            if (res.reason === 'manual') {
                window.__keynoteReportResult = { msg: '已提交，已收录 ✓', at: Date.now() };
                this.showToast('提交成功，已收录（手动）');
            } else if (res.reason === 'voted') {
                window.__keynoteReportResult = { msg: '已收录 ✓', at: Date.now() };
                this.showToast('已收录，感谢反馈（AI 3 票确认）');
            } else if (res.reason === 'pending') {
                this.showToast('已记录 ' + em.newKeyNote + ' ' + (em.newScale || '') + '（' + res.votes + '/3 票）');
            } else if (res.reason === 'exists') {
                window.__keynoteReportResult = { msg: '已存在，无需重复提交', at: Date.now() };
                this.showToast('这首歌曲的该基调已存在，无需重复提交');
            } else {
                window.__keynoteReportResult = { msg: '已记录（' + (res.votes || 1) + '/3 票）', at: Date.now() };
                this.showToast('已提交');
            }
        }).catch(() => {
            window.__keynoteReportResult = { msg: '提交失败：网络错误', at: Date.now() };
            this.showToast('提交失败：网络错误');
        });
    }
    // 用户操作的时候使用 设置升降调值和基调
    setSharpFlatValue(tune, isDebounce = false) {
        this.updateSharpFlatValue(tune, isDebounce);
        d_setUpdateKeynote(
            this.state.currentKeynote,
            tune,
            this.state.emSharpFlatState.value,
            this.state.isEnableAutotune,
            this.state.emPlugsV3
        );
        // 清空AI基调
        this.setState({
            // AI基调清空
            aiEmData: null,
            currentAiEm: null,
        });
        // 如果是自动恢复模式
        if (this.state.sharpFlatModel === "renew" && this.state.isInitLocalDb) {
            updateLocalDbTune(tune, this.state.playerData);
        }
    }
    // 伴奏助手模式下 设置升降调和基调
    accHelperSetSharpFlat(tune) {
        d_setUpdateKeynote(
            this.state.currentKeynote,
            tune,
            this.state.emSharpFlatState.value,
            this.state.isEnableAutotune,
            this.state.emPlugsV3
        );
        // 清空AI基调
        this.setState({
            // AI基调清空
            aiEmData: null,
            currentAiEm: null,
        });
        this.setSharpFlatState({
            value: tune,
        });
    }
    
    // 更新升降调值
    updateSharpFlatValue(tune, isDebounce = false) {
        let handleTune = setUpdateTune;
        // let handleWesingTune = cppUpdateWesingTune;
        if (isDebounce) {
            handleTune = d_setUpdateTune;
            // handleWesingTune = d_cppUpdateWesingTune;
        }
        // // 全民的时候调节全民本身的升降调 并且把其他升降掉归0
        // if (this.state.playerData.player === "wesing") {
        //     handleWesingTune(tune);
        // } else {
        //     handleTune(this.state.emPlugsV3, tune);
        // }
        handleTune(this.state.emPlugsV3, tune);
    }
    // 通过升降调改变基调 仅更新基调 不设置升降调
    updateKeyNoteByTune(tune) {
        this.setSharpFlatState({
            value: tune,
        });
        d_setUpdateKeynote(
            this.state.currentKeynote,
            tune,
            this.state.emSharpFlatState.value,
            this.state.isEnableAutotune,
            this.state.emPlugsV3
        );
    }
    // 更新消人声值
    updateVocalsValue(vocalsValue) {
        this.setState({
            vocalsValue: vocalsValue,
        });
        d_updateRemoveVocals(this.state.emPlugsV3, vocalsValue);
        // 如果是自动恢复模式
        if (this.state.vocalsModel === "renew" && this.state.isInitLocalDb) {
            updateLocalDbVocals(vocalsValue, this.state.playerData);
        }
    }
    // 设置播放器
    setCurrentPlayer(playerData) {
        this.setState({
            playerData: playerData,
            curSpk: "",
            emList: {},
            currentKeynote: {},
            // 电音升降调也初始化为0
            emSharpFlatState: {
                value: 0,
            },
            // AI基调清空
            aiEmData: null,
            currentAiEm: null,
        });
        this.isCheckedAiEm = false;
        this.getEmInfo(
            playerData.musicName,
            playerData.musicAuthor,
            playerData.player
        );
    }
    // 设置当前扬声器设备
    setCurSpk(spk) {
        this.setState({
            curSpk: spk,
            emList: {},
            currentKeynote: {},
            // 电音升降调也初始化为0
            emSharpFlatState: {
                value: 0,
            },
            // AI基调清空
            aiEmData: null,
            currentAiEm: null,
        });
        this.isCheckedAiEm = true;
        if (spk === "not-found-spk") {
            return;
        }
        // 是否启动频谱 如果频谱没有打开 则强制打开频谱
        const isEnableAudioFFT = getIsSetEnableAudioFFT();
        if (!isEnableAudioFFT) {
            cppEnableAudioFFT(true);
            setIsSetEnableAudioFFT(true);
        }
        // 封禁用户不开录音/频谱采集（AI 分析是本地算的，这里断掉输入）
        if (!this.state.banned) {
            cppResetEmusicKeynote();
            cppStartRecordDevice(spk);
        }
    }
    // 清空AI基调
    clearAiEm() {
        this.setState({
            aiEmData: null,
            currentAiEm: null,
        });
    }
    // 启用或者禁用自动电音
    setEnableAutotune(enable) {
        // 封禁用户不允许打开自动电音（基调不下发给插件）
        if (this.state.banned) {
            enable = false;
        }
        this.setState({
            isEnableAutotune: enable,
        });
        d_setUpdateKeynote(
            this.state.currentKeynote,
            this.state.sharpFlatState.value,
            this.state.emSharpFlatState.value,
            enable,
            this.state.emPlugsV3
        );
    }
    // 获取基调信息
    getEmInfo(musicName, musicAuthor, player) {
        if (!musicName && !musicAuthor) {
            return;
        }
        this.localDbEm = null;
        this.localDbAiEm = null;
        this.localAiFirst = null;
        let localTune = 0;
        let localVocals = 50;
        let localEmValue = {};
        if (this.state.isInitLocalDb) {
            const localMusicInfo = getMusicInfoFromLoadlDb({
                musicName: musicName,
                musicAuthor: musicAuthor,
            });
            if (Array.isArray(localMusicInfo)) {
                this.localDbEm = localMusicInfo[0];
                this.localDbAiEm = localMusicInfo[9];
                this.localAiFirst = localMusicInfo[8];
                localTune = parseInt(localMusicInfo[1], 10) || 0;
                localVocals =
                    typeof localMusicInfo[2] === "number"
                        ? parseInt(localMusicInfo[2], 10)
                        : 50;
                if (typeof localMusicInfo[3] === "number") {
                    localEmValue.rate = localMusicInfo[3];
                }
                if (typeof localMusicInfo[4] === "number") {
                    localEmValue.humanize = localMusicInfo[4];
                }
                if (typeof localMusicInfo[5] === "number") {
                    localEmValue.flex = localMusicInfo[5];
                }
                if (typeof localMusicInfo[6] === "number") {
                    localEmValue.vibrato = localMusicInfo[6];
                }
                if (typeof localMusicInfo[7] === "number") {
                    localEmValue.tracking = localMusicInfo[7];
                }
            }
        }
        const isAccHelper = this.state.AccModel === "伴奏助手"
        // 升降调模式为自动重置时 切歌将升降调设置为0
        if (this.state.sharpFlatModel === "reset" && !isAccHelper) {
            this.setSharpFlatState({ value: 0 });
            if (this.state.sharpFlatState.pluginAry.length) {
                this.updateSharpFlatValue(0);
            }
        } else if (this.state.sharpFlatModel === "renew" && !isAccHelper) {
            // 升降模式为自动恢复时 获取本地存储的升降调 如果存在就设置为本地值
            this.setSharpFlatState({ value: localTune });
            if (this.state.sharpFlatState.pluginAry.length) {
                this.updateSharpFlatValue(localTune);
            }
        }
        // 消人声模式为自动重置时 切歌将消人声设置为0
        if (this.state.vocalsModel === "reset" && !isAccHelper) {
            this.setState({
                vocalsValue: 50,
            });
            if (this.state.vocalsPluginState.length) {
                updateRemoveVocals(this.state.emPlugsV3, 50);
            }
        } else if (this.state.vocalsModel === "renew" && !isAccHelper) {
            // 消人声模式为自动恢复时 获取本地存储的消人声 如果存在就设置为本地值
            this.setState({
                vocalsValue: localVocals,
            });
            if (this.state.vocalsPluginState.length) {
                updateRemoveVocals(this.state.emPlugsV3, localVocals);
            }
        }
        // 电音参数模式位自动重置时
        if (this.state.emValueModel === "reset") {
            const defaultEmValue = getDefaultEmValue(
                this.state.productInfo.uiExtConf,
                "reset"
            );
            const _defaultEmValue = filterTargetEmValue(
                this.state.pageset,
                defaultEmValue
            );
            this.setEmValue(_defaultEmValue, true);
            setUpdateEmValues(this.state.emPlugsV3, _defaultEmValue);
        } else if (this.state.emValueModel === "renew") {
            const _localEmValue = filterTargetEmValue(
                this.state.pageset,
                localEmValue
            );
            this.setEmValue(_localEmValue, true);
            setUpdateEmValues(this.state.emPlugsV3, _localEmValue);
        } else if (this.state.emValueModel === "lock") {
            const _currentEmValue = filterTargetEmValue(
                this.state.pageset,
                this.state.emValue
            );
            setUpdateEmValues(this.state.emPlugsV3, _currentEmValue);
        }
        searchEm({
            musicName: musicName,
            musicAuthor: musicAuthor,
            musicProcess: player,
        })
            .then((res) => {
                let err = "";
                let emusics = null;
                if (
                    res &&
                    res.err === "ERR_OK" &&
                    res.emusicResp &&
                    Array.isArray(res.emusicResp.emusics) &&
                    res.emusicResp.emusics.length
                ) {
                    if (isNoEm(res.emusicResp.emusics)) {
                        err = "ERR_NO_EM";
                    } else {
                        err = "ERR_OK";
                        emusics = initEmList(res.emusicResp.emusics);
                    }
                } else if (res && res.err && res.err !== "ERR_OK") {
                    err = res.err;
                } else {
                    err = "EMPTY";
                }
                this.setState({
                    emList: {
                        err: err,
                        emusics: emusics,
                    },
                });
                this.setEmByLocalDb(this.localDbEm, this.localDbAiEm, emusics);
            })
            .catch((err) => {
                this.setEmByLocalDb(this.localDbEm, this.localDbAiEm);
                this.reBackupListCount = 5;
                this.handleEmErrInfo(err);
            });
    }
    handleEmErrInfo(err) {
        const vm = this;
        if (err && err.message === "Not Response") {
            const backupListState = window.localStorage.getItem(
                "sy_backup_list_state"
            );
            if (backupListState === "yes") {
                vm.setState({
                    emList: {
                        err: "NETWORK_ERR_D",
                    },
                });
            } else if (backupListState === "no") {
                vm.setState({
                    emList: {
                        err: "NETWORK_ERR",
                    },
                });
            } else if (vm.reBackupListCount > 0) {
                vm.reBackupListCount--;
                setTimeout(function () {
                    vm.handleEmErrInfo(err);
                }, 500);
            }
        } else {
            vm.setState({
                emList: {
                    err: "NETWORK_ERR",
                },
            });
        }
    }
    // 获取活动信息 有活动就打开活动页面
    openPromotions() {
        getPromotion().then((res) => {
            if (
                res &&
                res.err === "ERR_OK" &&
                res.promo &&
                res.promo.promoteUrl
            ) {
                this.setState({
                    promoteUrl: res.promo.promoteUrl,
                });
                setTimeout(() => {
                    openWindow(res.promo.promoteUrl + "?token=" + getToken());
                }, 3000);
            }
        });
    }
    // 打开热榜页面
    openHottop() {
        const today = new Date().toISOString().split("T")[0];
        const lastShownDate = localStorage.getItem("sy_em_shown_date");
        if (!lastShownDate || lastShownDate !== today) {
            // 如果今天还没有显示过弹框，显示弹框
            getLocalCnfJSON().then((res) => {
                if (res && res.data && res.data.autoShowHottopPage) {
                    const url =
                        res.data.hottopPageUrl || "https://dianyinx.com/";
                    setTimeout(() => {
                        openWindow(url);
                    }, 3000);
                }
            });
            // 更新 localStorage 记录
            localStorage.setItem("sy_em_shown_date", today);
        }
    }
    // 被封禁：不光盖遮罩，把已经在界面上的东西一起清掉
    // （遮罩只是视觉，清了数据才等于“没得看”）
    // 被封禁 / 会员过期：不光盖遮罩，把已经在界面上的东西一起清掉
    // （遮罩只是视觉，清了数据才等于“没得看”）
    applyBannedState() {
        if (this.state.banned) return;
        this.setState({
            banned: true,
            // 自动电音必须关掉：setUpdateKeynote 里 isEnableAutotune=false 会直接 return，
            // 基调就不会下发到电音插件 —— 这才是真正断功能，不是盖一层
            isEnableAutotune: false,
            // 清掉基调/列表/AI 结果/播放器信息（emList 是对象，不是数组）
            currentKeynote: {},
            emList: {},
            aiEmData: null,
            currentAiEm: null,
            playerData: {},
            // 清掉 AI 分析用的频谱数据
            vocalsPluginState: [],
        });
        try {
            // 关掉频谱采集，柱形图就不动了
            cppEnableAudioFFT(false);
            setIsSetEnableAudioFFT(false);
        } catch (e) { }
        try {
            // 清掉录音端已经攒下来的基调数据
            cppResetEmusicKeynote();
        } catch (e) { }
        // 兜底：立刻用「关闭自动电音」再下发一次，确保插件那边拿到的是空
        try {
            setUpdateKeynote(this.state.currentKeynote, 0, 0, false, this.state.emPlugsV3);
        } catch (e) { }
        try {
            cppUpdateKeynote('');
        } catch (e) { }
    }
    // 获取VIP信息并且展示
    getVipInfo() {
        getVipCheck().then((res) => {
            if (res && res.err === "ERR_OK" && res.vipInfo) {
                this.setState({ vipInfo: res.vipInfo, vipChecked: true });
                if (res.vipInfo.banned) {
                    this.applyBannedState();
                } else if (res.vipInfo.isExpire) {
                    // 会员过期：跟封禁一样断掉所有功能，只是出口是「立即续费」
                    this.applyBannedState();
                }
            }
        });
    }
    // 被封禁时唯一的出口：联系客服
    openServicePage() {
        openWindow(window.location.origin + window.location.pathname + '#/help');
    }
    // 会员过期时唯一的出口：充值页
    openPayPage() {
        const base = window.__EM_API_BASE__ || window.location.origin;
        openWindow(base + '/empay/?token=' + getToken());
    }
    // 设置电音升降调
    setEmSharpFlatState(value) {
        this.setState({
            emSharpFlatState: {
                value: value,
            },
        });
        d_setUpdateKeynote(
            this.state.currentKeynote,
            this.state.sharpFlatState.value,
            value,
            this.state.isEnableAutotune,
            this.state.emPlugsV3
        );
    }
    // 展示/关闭自定义基调设置
    handleShowEmSet() {
        this.setState({
            isShowEmSet: !this.state.isShowEmSet,
        });
    }
    // 设置页面配置
    handlePageset(cnf) {
        if (!cnf) {
            return false;
        }
        const newPageset = Object.assign({}, this.state.pageset, cnf);
        this.setState({
            pageset: newPageset,
        });
        // 将配置保存到本地
        setPageset(newPageset);
    }
    // 设置页面置顶
    handleSetIsTop(isTop) {
        this.setState({
            isTop: isTop,
        });
        setIsTop(isTop);
    }
    // 重载本地配置
    // forceRefresh=true 时先从服务端重新拉一次产品配置：
    // 「恢复默认」走这条路，这样后台改过的默认值能立刻生效，而不是用启动时缓存的旧 uiExtConf
    reloadLocalCnf(forceRefresh) {
        const apply = (productInfo) => {
            this.applyLocalCnf(productInfo);
            if (!forceRefresh) return;
            // 恢复默认：光改界面不够，还得把参数真正推给插件
            try {
                const defaults = getDefaultEmValue(productInfo.uiExtConf, getEmValueModel());
                setUpdateEmValues(this.state.emPlugsV3, defaults);
                console.log('[恢复默认] 已按后台配置重建', JSON.stringify(defaults));
            } catch (e) { }
        };
        if (forceRefresh) {
            initProduct()
                .then(apply)
                .catch(() => apply(this.state.productInfo));
            return;
        }
        apply(this.state.productInfo);
    }
    // 恢复默认：直接拉后台的「电音精调默认值」，写进本机设置，再重建
    // 不走 productInfo 缓存，后台改完立即生效
    restoreServerDefaults(done) {
        const finish = () => {
            this.reloadLocalCnf(true);
            if (done) done();
        };
        getUiExtConf().then((res) => {
            const d = res && res.uiext;
            if (!res || res.err !== 'ERR_OK' || !d || Number(d.enabled) === 0) {
                console.log('[恢复默认] 后台没配或已关闭下发，用客户端自带默认');
                finish();
                return;
            }
            try {
                this.writeDefaultsToLocal(d);
                console.log('[恢复默认] 已写入后台配置 v' + d.version);
            } catch (e) {
                console.log('[恢复默认] 写入失败', e && e.message);
            }
            finish();
        }).catch((e) => {
            console.log('[恢复默认] 拉取后台配置失败', e && e.message);
            finish();
        });
    }
    // 把后台默认值写进 localStorage（面板读的就是这些键）
    writeDefaultsToLocal(d) {
        const keys = ['rate', 'humanize', 'flex', 'vibrato', 'tracking'];
        const preSetters = {
            rate: setRatePre,
            humanize: setHumanizePre,
            flex: setFlexPre,
            vibrato: setVibratoPre,
            tracking: setTrackingPre,
        };
        const emValue = {};
        const params = d.params || {};
        keys.forEach((k) => {
            const p = params[k] || {};
            const presets = p.presets || [];
            const pre = { name: p.name || k, isInit: true, value: Number(p.value) || 0 };
            for (let i = 0; i < 4; i++) {
                const item = presets[i] || {};
                pre['pre' + (i + 1)] = { name: item.name || '', value: Number(item.value) || 0 };
            }
            preSetters[k](pre);
            emValue[k] = Number(p.value) || 0;
        });
        setDefaultEmValue(emValue);

        const s = d.shortcuts || {};
        const pickShortcut = (o) => {
            const src = o || {};
            return {
                name: src.name || '',
                rate: Number(src.rate) || 0,
                humanize: Number(src.humanize) || 0,
                vibrato: Number(src.vibrato) || 0,
                flex: Number(src.flex) || 0,
                tracking: Number(src.tracking) || 0,
            };
        };
        setEmShortcut({
            pre1: pickShortcut(s.pre1),
            pre2: pickShortcut(s.pre2),
            pre3: pickShortcut(s.pre3),
        });
        const link = s.link || {};
        setShortcutLink({
            rate: !!link.rate,
            humanize: !!link.humanize,
            vibrato: !!link.vibrato,
            flex: !!link.flex,
            tracking: !!link.tracking,
        });
        // 按模式区分快捷配置会绕过后台配的预设，恢复默认时关掉
        setIsSetShortcutByEmModel(false);

        const items = (d.linkage && d.linkage.items) || {};
        const emLinkage = {};
        keys.forEach((k) => {
            const it = items[k] || {};
            emLinkage[k] = {
                isLink: !!it.isLink,
                start: Number(it.start) || 0,
                end: Number(it.end) || 0,
            };
        });
        setEmLinkage(emLinkage);

        // 底栏勾选框（哪些功能显示出来）
        if (d.pageset) {
            const pageset = {};
            Object.keys(d.pageset).forEach((k) => {
                pageset[k] = !!d.pageset[k];
            });
            setPageset(pageset);
        }
    }
    // 用给定的产品配置重建本地状态
    applyLocalCnf(productInfo) {
        const emValueModel = getEmValueModel();
        const defaultEmValue = getDefaultEmValue(
            productInfo.uiExtConf,
            emValueModel
        );
        const shortcut = getEmShortcut(
            new DefautlShortcut(),
            productInfo.uiExtConf
        );
        const shortcutLink = getShortcutLink(
            new DefaultShortcutLink(),
            productInfo.uiExtConf
        );
        const isSetShortcutByEmModel = getIsSetShortcutByEmModel(
            productInfo.uiExtConf
        );
        const emModelShortcut = getEmModelShortcut(
            new DefaultEmModelShortcut(),
            productInfo.uiExtConf
        );
        const shortcutList = getShortcutList(
            shortcut,
            emModelShortcut,
            this.state.pluginModel.value,
            isSetShortcutByEmModel
        );
        // const currentShortcutName = getCurrentShortcutName(shortcutList, shortcutLink, defaultEmValue);
        // 获取预配置
        const emPre = {
            rate: getRatePre(new Rate(), productInfo.uiExtConf),
            flex: getFlexPre(new Flex(), productInfo.uiExtConf),
            humanize: getHumanizePre(new Humanize(), productInfo.uiExtConf),
            vibrato: getVibratoPre(new Vibrato(), productInfo.uiExtConf),
            tracking: getTrackingPre(new Tracking(), productInfo.uiExtConf),
        };
        // 联动调节
        const emLinkage = getEmLinkage(new EmLinkage(), productInfo.uiExtConf);
        this.setState({
            productInfo: productInfo,
            isTop: getIsTop(productInfo.uiExtConf),
            pageset: getPageset(new DefaultPageset(), productInfo.uiExtConf),
            isAiFirst: getIsAiFirst(),
            sharpFlatModel: getSharpflatModel(),
            vocalsModel: getVocalsModel(),
            pluginModel: getEmPluginModel(),
            emValueModel: emValueModel,
            emValue: defaultEmValue,
            shortcut: shortcut,
            shortcutLink: shortcutLink,
            isSetShortcutByEmModel: isSetShortcutByEmModel,
            emModelShortcut: emModelShortcut,
            shortcutList: shortcutList,
            presetConfig: getPresetConfig(emPre),
            emLinkage: emLinkage,
            emModelNames: getEmModelNames(productInfo.uiExtConf),
            emTexts: getEmTexts(productInfo.uiExtConf),
            playerCaps: getPlayerCaps(productInfo.uiExtConf),
            AccModel: getLocalAccModel()
            // currentShortcutName: currentShortcutName,
        });
        // 通知别的页面
        cppBroadcastWndMsg("Reload_State");
    }
    // 设置当前的AI分析基调
    setCurrentAiEm(em) {
        this.setState({
            currentAiEm: em,
        });
        if (this.isCheckedAiEm) {
            this.setCurrentKeyNote(em);
        }
    }
    // 设置AI基调优先
    setAiEmFirst(isAiFirst) {
        this.setState({
            isAiFirst: isAiFirst,
        });
        setIsAiFirst(isAiFirst);
    }
    // 设置是否选择AI基调
    setIsCheckedAiEm(checked) {
        this.isCheckedAiEm = checked;
        // 修改本地数据库是否AI基调优先
        if (checked) {
            // 和写入本地基调冲突 加个延迟
            setTimeout(() => {
                updateAiFirst(1, this.state.playerData);
            }, 500);
        } else {
            setTimeout(() => {
                updateAiFirst(0, this.state.playerData);
            }, 500);
        }
    }
    // 创建随机基调
    createRandomEm(count) {
        const vm = this;
        const randomEm = getRandomEm(1);
        vm.setState({
            aiEmData: randomEm,
        });
        count--;
        if (count > 0) {
            setTimeout(() => {
                vm.createRandomEm(count);
            }, 200);
        }
    }
    // 设置电音参数
    setEmValue(obj, local) {
        const newState = Object.assign({}, this.state.emValue, obj);
        // const newState = {...this.state.emValue, ...obj}
        this.setState({
            emValue: newState,
        });
        if (!local) {
            d_setDefaultEmValue(newState);
        }
    }
    // 设置插件模式
    setPluginModel(pluginModel) {
        this.setState({
            pluginModel: pluginModel,
        });
        setEmPluginModel(pluginModel);
        // 如果开启了电音模式关联快捷配置模式 则重新生成快捷键列表
        // 顺道将选择的当前快捷键清空
        if (this.state.isSetShortcutByEmModel) {
            const shortcutList = getShortcutList(
                this.state.shortcut,
                this.state.emModelShortcut,
                pluginModel.value,
                this.state.isSetShortcutByEmModel
            );
            console.log(shortcutList);
            this.setState({
                shortcutList: shortcutList,
                currentShortcutName: "",
            });
        }
    }
    // 设置当前快捷键名称
    setCurrentShortcutName(name) {
        this.setState({
            currentShortcutName: name,
        });
    }
    // 回到登陆页
    handleToLogin() {
        this.props.history.push({
            pathname: "/login",
        });
    }
    // 设置菜单显示
    setshowmenu(isShow) {
        this.setState({
            showmenu: isShow,
        });
    }
    // 设置插件弹框状态
    setPluginTipDiaState(s) {
        this.setState({
            pluginTipDiaState: s
        })
    }
    // 设置伴奏模式
    setAccModel(model) {
        // 设置为伴奏模式时将消人声和升降调设置为0
        if (model === "伴奏助手") {
            this.setSharpFlatState({ value: 0 });
            if (this.state.sharpFlatState.pluginAry.length) {
                this.updateSharpFlatValue(0);
            }
            this.setState({
                vocalsValue: 50,
                AccHelperValue: "0",
            });
            if (this.state.vocalsPluginState.length) {
                updateRemoveVocals(this.state.emPlugsV3, 50);
            }
        } else {
            // 退出伴奏模式时将升降调恢复
            this.accHelperSetSharpFlat(0)
        }
        this.setState({
            AccModel: model
        });
        setLocalAccModel(model);
    }
    // 当前播放器支持哪些功能（升降调 / 消人声）
    getCurrentPlayerCap() {
        const player = this.state.playerData && this.state.playerData.player;
        // 还没识别到播放器时不拦，保持原样（不能因为"没检测到"就把控件换掉）
        if (!player) {
            return { tune: 'support', vocals: 'support', hint: '' };
        }
        const cap = getPlayerCap(this.state.playerCaps, player);
        return cap;
    }
    // 当前播放器不支持 → 引导切到伴奏助手
    switchToAccHelper() {
        this.setAccModel("伴奏助手");
    }
    // 升降调 / 消人声两行：按能力表决定显示控件、提示文字，还是「切换伴奏助手」
    renderPlayerFeatureRows() {
        const pageset = this.state.pageset
        const cap = this.getCurrentPlayerCap()
        // 两个功能都不支持时合并成一个按钮，不重复显示两遍
        const accList = []
        if (pageset.vocals && cap.vocals === 'acc') accList.push('消人声')
        if (pageset.sharpFlat && cap.tune === 'acc') accList.push('升降调')

        const rows = []
        let accDone = false
        const pushAcc = () => {
            if (accDone || !accList.length) return
            accDone = true
            rows.push(
                <SwitchAccHelper
                    key="acc-helper"
                    mode="acc"
                    features={accList}
                    onClick={this.switchToAccHelper}
                ></SwitchAccHelper>
            )
        }

        // 消人声
        if (pageset.vocals) {
            if (cap.vocals === 'support') {
                rows.push(
                    <RemoveVocals
                        key="vocals"
                        pageset={pageset}
                        vocalsValue={this.state.vocalsValue}
                        updateVocalsValue={this.updateVocalsValue}
                        vocalsPluginState={this.state.vocalsPluginState}
                        setPluginTipDiaState={this.setPluginTipDiaState}
                    ></RemoveVocals>
                )
            } else if (cap.vocals === 'hint') {
                rows.push(
                    <SwitchAccHelper key="vocals-hint" mode="hint" features={['消人声']} hint={cap.hint}></SwitchAccHelper>
                )
            } else if (cap.vocals === 'acc') {
                pushAcc()
            }
        }

        // 升降调
        if (pageset.sharpFlat) {
            if (cap.tune === 'support') {
                rows.push(
                    <YunSharpFlat
                        key="sharpflat"
                        pageset={pageset}
                        sharpFlatState={this.state.sharpFlatState}
                        updateSharpFlatValue={this.updateSharpFlatValue}
                        setSharpFlatValue={this.setSharpFlatValue}
                        setSharpFlatState={this.setSharpFlatState}
                        setPluginTipDiaState={this.setPluginTipDiaState}
                    ></YunSharpFlat>
                )
            } else if (cap.tune === 'hint') {
                rows.push(
                    <SwitchAccHelper key="tune-hint" mode="hint" features={['升降调']} hint={cap.hint}></SwitchAccHelper>
                )
            } else if (cap.tune === 'acc') {
                pushAcc()
            }
        }

        return rows
    }
    // 设置SMTC
    setIsSMTC(isSMTC) {
        this.setState({
            isSMTC: isSMTC
        })
    }
    // 主动初始化受限判断
    initRestrictedJudge() {
        restrictedJudge().then((res) => {
            console.log("受限判断结果====", res);
            if (res && res.restrict && res.restrict.restricted) {
                wafCaptchaManager.setNeedRestricted(true);
            }
        })
    }
    componentDidMount() {
        // AI 基调自动回传（每 30 秒检查一次）
        this.keynoteReportTimer = setInterval(() => {
            try { this.tickReportAiKeynote(); } catch (e) {}
        }, 30 * 1000);
        // 会员状态心跳：后台改了到期时间 / 封禁，最多 1 分钟生效，不用重启客户端
        this.vipHeartbeatTimer = setInterval(() => {
            try { this.getVipInfo(); } catch (e) {}
        }, 60 * 1000);
        // 暴露给界面：手动提交修正基调
        window.__reportKeynote = (source) => this.reportKeynote(this.state.currentKeynote, source || '手动');
        // 任何一个接口回了 ERR_USER_DISABLED，立刻盖上封禁遮罩（ajax 拦截器里会调它）
        window.__onUserDisabled = () => {
            this.applyBannedState();
        };
        // 初始化产品信息
        initProduct().then((productInfo) => {
            // 当前默认参数
            const defaultEmValue = getDefaultEmValue(
                productInfo.uiExtConf,
                this.state.emValueModel
            );
            // 快捷选项
            const shortcut = getEmShortcut(
                new DefautlShortcut(),
                productInfo.uiExtConf
            );
            // 快捷选项关联
            const shortcutLink = getShortcutLink(
                new DefaultShortcutLink(),
                productInfo.uiExtConf
            );
            // 是否启动按模式区分
            const isSetShortcutByEmModel = getIsSetShortcutByEmModel(
                productInfo.uiExtConf
            );
            // 各个模式下的快捷选项
            const emModelShortcut = getEmModelShortcut(
                new DefaultEmModelShortcut(),
                productInfo.uiExtConf
            );
            // 快捷列表
            const shortcutList = getShortcutList(
                shortcut,
                emModelShortcut,
                this.state.pluginModel.value,
                isSetShortcutByEmModel
            );
            // 获取预配置
            const emPre = {
                rate: getRatePre(new Rate(), productInfo.uiExtConf),
                flex: getFlexPre(new Flex(), productInfo.uiExtConf),
                humanize: getHumanizePre(new Humanize(), productInfo.uiExtConf),
                vibrato: getVibratoPre(new Vibrato(), productInfo.uiExtConf),
                tracking: getTrackingPre(new Tracking(), productInfo.uiExtConf),
            };
            // 联动调节
            const emLinkage = getEmLinkage(
                new EmLinkage(),
                productInfo.uiExtConf
            );
            this.setState({
                productInfo: productInfo,
                isTop: getIsTop(productInfo.uiExtConf),
                pageset: getPageset(
                    new DefaultPageset(),
                    productInfo.uiExtConf
                ),
                emValue: defaultEmValue,
                presetConfig: getPresetConfig(emPre),
                shortcut: shortcut,
                shortcutLink: shortcutLink,
                isSetShortcutByEmModel: isSetShortcutByEmModel,
                emModelShortcut: emModelShortcut,
                shortcutList: shortcutList,
                emLinkage: emLinkage,
                emModelNames: getEmModelNames(productInfo.uiExtConf),
            emTexts: getEmTexts(productInfo.uiExtConf),
                playerCaps: getPlayerCaps(productInfo.uiExtConf),
            });
        });
        // 初始化电音相关配置
        initEmConfig((emPlugsV3) => {
            this.setState({
                emPlugsV3: emPlugsV3,
            });
        });
        // 监听登录状态
        // const props = this.props
        const vm = this;
        loginState.watchState("login", function (res) {
            if (res && res.err === "ERR_NOT_LOGIN") {
                // props.history.push({
                //     pathname: '/'
                // });
                // vm.setState({
                //     msgBoxOption: {
                //         show: true,
                //         msg: "登录过期，请重新登录",
                //     }
                // })
                vm.handleToLogin();
            }
            if (res && res.err === "ERR_USER_ALREADY_LOGIN_OTHER_PLACE") {
                vm.setState({
                    msgBoxOption: {
                        show: true,
                        msg: "您的账号已经在别的设备登录，请重新登录!",
                    },
                });
            }
        });
        // 账号受限解除后，重新获取一次基调信息
        this.onRestrictedResolved = () => {
            this.getEmInfo(
                this.state.playerData.musicName,
                this.state.playerData.musicAuthor,
                this.state.playerData.player
            );
        };
        wafCaptchaManager.onRestrictedResolved(this.onRestrictedResolved);
        // 获取vip状态
        this.getVipInfo();
        // 打开活动页面
        this.openPromotions();
        // 打开热榜
        this.openHottop();
        // 主动初始化受限判断
        this.initRestrictedJudge();
        // 设置主窗口
        cppSetToMainWindow();
        // vst3是否远程执行
        // cppSetVst3AutoRemote(false);
        // 初始化本地数据库
        initLocalDb();
        this.setState({
            isInitLocalDb: true,
        });
        // 监听播放器切歌
        try {
            window.onMusicChange = (musicName, musicAuthor, player) => {
                console.log("================", musicName, musicAuthor, player);
                if (this.state.isSMTC) {
                    return false;
                }
                this.setCurrentPlayer({
                    musicName: trimFirstAndLastSpace(musicName),
                    musicAuthor: trimFirstAndLastSpace(musicAuthor),
                    player: player,
                });
                // for (let i = 0; i < 50; i++) {
                //     setTimeout(() => {
                //         console.log(i);
                //         cppResetEmusicKeynote()
                //     }, 100 * i);
                // }
                cppResetEmusicKeynote();
                const processName = getPlayerProcessName(player);
                cppStartRecordDeviceByProcessName(processName);

                // cppResetEmusicKeynote();cppStartRecordDeviceByProcessName("KuGou.exe");
                // cppResetEmusicKeynote();cppStartRecordDevice("System Audio (U12s)");
                if (this.aiEmTimer) {
                    clearTimeout(this.aiEmTimer);
                }
                this.aiEmCount = 0;
            };
        } catch (error) {}
        // 监听插件状态 包括升降调
        try {
            window.onPluginStatChange = (name, online) => {
                if (typeof name === "string" && name.includes("升降调")) {
                    const sharpFlatPluginAry = JSON.parse(
                        JSON.stringify(this.state.sharpFlatState.pluginAry)
                    );
                    if (online) {
                        sharpFlatPluginAry.push(name);
                    } else {
                        const index = sharpFlatPluginAry.indexOf(name);
                        if (index !== -1) {
                            sharpFlatPluginAry.splice(index, 1);
                        }
                    }
                    this.setSharpFlatState({
                        pluginAry: sharpFlatPluginAry,
                        online: Boolean(sharpFlatPluginAry.length),
                    });
                } else if (
                    typeof name === "string" &&
                    name.includes("消人声")
                ) {
                    const removeVocalsPluginAry = JSON.parse(
                        JSON.stringify(this.state.vocalsPluginState)
                    );
                    if (online) {
                        removeVocalsPluginAry.push(name);
                    } else {
                        const index = removeVocalsPluginAry.indexOf(name);
                        if (index !== -1) {
                            removeVocalsPluginAry.splice(index, 1);
                        }
                    }
                    this.setState({
                        vocalsPluginState: removeVocalsPluginAry,
                    });
                } else if (name) {
                    const pluginAry = JSON.parse(
                        JSON.stringify(this.state.emPluginState)
                    );
                    if (online) {
                        pluginAry.push(name);
                    } else {
                        const index = pluginAry.indexOf(name);
                        if (index !== -1) {
                            pluginAry.splice(index, 1);
                        }
                    }
                    this.setState({
                        emPluginState: pluginAry,
                    });
                }
            };
        } catch (error) {}
        // 监听别的页面的通知消息
        try {
            window.onRecvBroadcastWndMsg = (msg) => {
                if (typeof msg !== "string") {
                    return false;
                }
                if (msg === "Pay_Success") {
                    // 到期充值之后，重新查询一次基调
                    this.getEmInfo(
                        this.state.playerData.musicName,
                        this.state.playerData.musicAuthor,
                        this.state.playerData.player
                    );
                    this.getVipInfo();
                }
                // 收到插件同步消息 将插件状态发送一份
                if (msg === "Init_Plugin_State") {
                    const emPluginStateStr =
                        "EmpluginstateInfo" +
                        JSON.stringify(this.state.emPluginState);
                    const sharpFlatPluginStateStr =
                        "sharpFlatPluginStateInfo" +
                        JSON.stringify(this.state.sharpFlatState);
                    const vocalsPluginStateStr =
                        "vocalsPluginStateInfo" +
                        JSON.stringify(this.state.vocalsPluginState);
                    cppBroadcastWndMsg(emPluginStateStr);
                    cppBroadcastWndMsg(sharpFlatPluginStateStr);
                    cppBroadcastWndMsg(vocalsPluginStateStr);
                }
                // 设置升降调模式
                if (/^SharpFlatModel/.test(msg)) {
                    this.setState({
                        sharpFlatModel: msg.replace("SharpFlatModel", ""),
                    });
                }
                // 设置消人声模式
                if (/^VocalsModel/.test(msg)) {
                    this.setState({
                        vocalsModel: msg.replace("VocalsModel", ""),
                    });
                }
                // 设置精调参数模式
                if (/^EmValueModel/.test(msg)) {
                    this.setState({
                        emValueModel: msg.replace("EmValueModel", ""),
                    });
                }
                // 更新电音精调参数
                if (/^UpdateEmShortcut/.test(msg)) {
                    // 快捷选项
                    const shortcut = getEmShortcut(
                        new DefautlShortcut(),
                        this.state.productInfo.uiExtConf
                    );
                    // 快捷选项关联
                    const shortcutLink = getShortcutLink(
                        new DefaultShortcutLink(),
                        this.state.productInfo.uiExtConf
                    );
                    // 是否启动按模式区分
                    const isSetShortcutByEmModel = getIsSetShortcutByEmModel(
                        this.state.productInfo.uiExtConf
                    );
                    // 各个模式下的快捷选项
                    const emModelShortcut = getEmModelShortcut(
                        new DefaultEmModelShortcut(),
                        this.state.productInfo.uiExtConf
                    );
                    // 快捷列表
                    const shortcutList = getShortcutList(
                        shortcut,
                        emModelShortcut,
                        this.state.pluginModel.value,
                        isSetShortcutByEmModel
                    );
                    this.setState({
                        shortcut: shortcut,
                        shortcutLink: shortcutLink,
                        isSetShortcutByEmModel: isSetShortcutByEmModel,
                        emModelShortcut: emModelShortcut,
                        shortcutList: shortcutList,
                    });
                }
                // 更新电音预配置参数
                if (/^UpdateEmPre/.test(msg)) {
                    const emPre = {
                        rate: getRatePre(
                            new Rate(),
                            this.state.productInfo.uiExtConf
                        ),
                        flex: getFlexPre(
                            new Flex(),
                            this.state.productInfo.uiExtConf
                        ),
                        humanize: getHumanizePre(
                            new Humanize(),
                            this.state.productInfo.uiExtConf
                        ),
                        vibrato: getVibratoPre(
                            new Vibrato(),
                            this.state.productInfo.uiExtConf
                        ),
                        tracking: getTrackingPre(
                            new Tracking(),
                            this.state.productInfo.uiExtConf
                        ),
                    };
                    this.setState({
                        presetConfig: getPresetConfig(emPre),
                    });
                }
                // 更新联动调节
                if (/^UpdateEmLinkage/.test(msg)) {
                    const emLinkage = getEmLinkage(
                        new EmLinkage(),
                        this.state.productInfo.uiExtConf
                    );
                    this.setState({
                        emLinkage: emLinkage,
                    });
                }
            };
        } catch (error) {}
        // 实时音频基调阶段音频流分析结果通知
        try {
            window.onRuntimeKeynote = (keynote) => {
                // 会员过期不提供服务
                if (this.state.vipInfo.isExpire) {
                    return;
                }
                // 非扬声器模式并且ai模块隐藏的情况下不提供ai分析结果
                if (!this.state.pageset.aiEm && !this.state.curSpk && this.state.curSpk !== "not-found-spk") {
                    return
                }
                // 切歌后放弃前两帧数据
                if (this.aiEmCount < 2) {
                    this.createRandomEm(3);
                    this.aiEmCount += 1;
                    return;
                }
                keynote = JSON.parse(keynote);
                const em = getAiEmByIndex(keynote.key, keynote.frame_pos);
                this.setState({
                    aiEmData: em,
                });
            };
            // window.onKeynoteResult = (keynote) => {
            //     console.log("222222222");
            //     console.log(keynote);
            // }
        } catch (error) {}
        
        // 通用监听
        try {
            window.onRemoteEventCallback = (obj) => {
                if (this.state.AccModel !== "伴奏助手") {
                    return;
                }
                const remoteData = JSON.parse(obj);
                if (remoteData && remoteData.data && typeof remoteData.data.pitchValue === "number") {
                    this.setState({
                        AccHelperValue: remoteData.data.pitchValue > 0 ? `+${remoteData.data.pitchValue}` : `${remoteData.data.pitchValue}`
                    })
                    this.accHelperSetSharpFlat(remoteData.data.pitchValue);
                }
            }
        } catch (error) {}

        // 监听SMTC媒体播放信息
        try {
            window.onSmtcMediaInfoChange = (obj) => {
                if (!this.state.isSMTC) {
                    return false;
                }
                const mediaInfo = JSON.parse(obj);
                const { musicName, musicAuthor } = this.state.playerData;
                const title = trimFirstAndLastSpace(mediaInfo.title);
                const artist = trimFirstAndLastSpace(mediaInfo.artist);
                
                // 检查是否与当前播放的歌曲信息完全相同
                if (title === musicName && artist === musicAuthor) {
                    return false;
                }
                // 检测滚动式消息：如果新title与上一次存储的title相似度很高，则忽略
                if (this.lastSmtcTitle && isScrollingTitle(title, this.lastSmtcTitle)) {
                    return false;
                }
                // 存储新的title信息，用于后续滚动消息检测
                this.lastSmtcTitle = title;
                this.setCurrentPlayer({
                    musicName: title,
                    musicAuthor: artist,
                    player: "",
                });
                cppResetEmusicKeynote();
                cppStartRecordDeviceByProcessName(mediaInfo.sourceAppId);
            }
        } catch (error) {}

        // 监听
        try {
            window.onPlayerToneChange = (tone, player) => {
                console.log('onPlayerToneChange===========', tone, player);
                if (this.state.playerData.player === "wesing" && player === "wesing") {
                    this.updateKeyNoteByTune(tone)
                }
            }
        } catch (error) {}

        // try {
        //     window.onRunWebToolFunctionCallback = (res) => {
        //         console.log(res);
        //         res = JSON.parse(res)
        //         if (res.cmd === "cmd_load_script" && res.err === 0) {
        //             const data = {
        //                 "entry": ".\\script\\webtool.lua",
        //                 "functionName":"GetSystemEnv",
        //                 "param":{
        //                     "env":"APPDATA"
        //                 }
        //             }
        //             const userData = "this is a string"
        //             cppRunWebToolFunctionCallScrtptFun(data, userData)
        //         }
        //     }
        // } catch (error) {
        // }
    }
    componentWillUnmount() {
        window.onMusicChange = null;
        window.onPluginStatChange = null;
        window.onRecvBroadcastWndMsg = null;
        window.onRuntimeKeynote = null;
        window.onRemoteEventCallback = null;
        window.onSmtcMediaInfoChange = null;
        window.onPlayerToneChange = null;
        
        if (this.aiEmTimer) {
            clearTimeout(this.aiEmTimer);
        }
        if (this.keynoteReportTimer) {
            clearInterval(this.keynoteReportTimer);
        }
        if (this.vipHeartbeatTimer) {
            clearInterval(this.vipHeartbeatTimer);
        }
        if (this.onRestrictedResolved) {
            wafCaptchaManager.offRestrictedResolved(this.onRestrictedResolved);
        }
        closeDb();
    }
    render() {
        const isAccHelper = this.state.AccModel === "伴奏助手"
        // 封禁：整个界面只渲染账号区，功能组件一个都不挂载（不是遮挡，是真的没有）
        if (this.state.banned) {
            const expired = this.state.vipChecked && this.state.vipInfo.isExpire;
            return (
                <div className="App AppContainer BannedOnly">
                    <YunHeader
                        productInfo={this.state.productInfo}
                        isTop={this.state.isTop}
                        showVip={true}
                        handleSetIsTop={this.handleSetIsTop}
                        emPlugsV3={this.state.emPlugsV3}
                        sharpFlatState={this.state.sharpFlatState}
                        isAccHelper={false}
                    ></YunHeader>
                    <div className="BannedBox">
                        <div className="BannedBoxTitle">{expired ? '会员已过期' : '账号已被封禁'}</div>
                        <div className="BannedBoxPhone">{this.state.vipInfo.userPhone || ''}</div>
                        <div className="BannedBoxDesc">
                            {expired ? '所有功能已停用，续费后才能继续使用' : '所有功能已停用，如需解封请联系客服'}
                        </div>
                        <div
                            className="BannedBoxBtn"
                            onClick={expired ? this.openPayPage.bind(this) : this.openServicePage.bind(this)}
                        >
                            {expired ? '立即续费' : '联系客服解封'}
                        </div>
                    </div>
                </div>
            );
        }
        return (
            <div className="App AppContainer">
                <YunHeader
                    productInfo={this.state.productInfo}
                    isTop={this.state.isTop}
                    showVip={!this.state.vipInfo.isExpire}
                    handleSetIsTop={this.handleSetIsTop}
                    emPlugsV3={this.state.emPlugsV3}
                    sharpFlatState={this.state.sharpFlatState}
                    isAccHelper={isAccHelper}
                ></YunHeader>
                {/* 封禁提示条：不遮挡界面，只占一条 */}
                {this.state.banned && (
                    <div className="BannedBanner" onClick={this.openServicePage.bind(this)}>
                        <span className="BannedBannerText">
                            <YunIcon iconClass="BannedBannerIcon" icon="lock"></YunIcon>
                            账号已被封禁
                        </span>
                        <span className="BannedBannerBtn">联系客服解封</span>
                    </div>
                )}
                <YunEmList
                    emTexts={this.state.emTexts}
                    pageset={this.state.pageset}
                    isExpire={this.state.vipInfo.isExpire}
                    isBanned={this.state.banned}
                    emPluginState={this.state.emPluginState}
                    emList={this.state.emList}
                    sharpFlatState={this.state.sharpFlatState}
                    emSharpFlatState={this.state.emSharpFlatState}
                    currentKeynote={this.state.currentKeynote}
                    setCurrentKeyNote={this.setCurrentKeyNote}
                    isShowEmSet={this.state.isShowEmSet}
                    handleShowEmSet={this.handleShowEmSet}
                    aiEmData={this.state.aiEmData}
                    currentAiEm={this.state.currentAiEm}
                    setCurrentAiEm={this.setCurrentAiEm}
                    isAiFirst={this.state.isAiFirst}
                    isAutoAiFirst={this.state.isAutoAiFirst}
                    setAiEmFirst={this.setAiEmFirst}
                    setIsCheckedAiEm={this.setIsCheckedAiEm}
                    curSpk={this.state.curSpk}
                    clearAiEm={this.clearAiEm}
                ></YunEmList>
                <YunEmSharpFlat
                    pageset={this.state.pageset}
                    emSharpFlatState={this.state.emSharpFlatState}
                    setEmSharpFlatState={this.setEmSharpFlatState}
                ></YunEmSharpFlat>
                <YunEmFineTune
                    pageset={this.state.pageset}
                    playerData={this.state.playerData}
                    emValue={this.state.emValue}
                    setEmValue={this.setEmValue}
                    presetConfig={this.state.presetConfig}
                    shortcutList={this.state.shortcutList}
                    isSetShortcutByEmModel={this.state.isSetShortcutByEmModel}
                    pluginModel={this.state.pluginModel}
                    setPluginModel={this.setPluginModel}
                    shortcutLink={this.state.shortcutLink}
                    emPluginState={this.state.emPluginState}
                    currentShortcutName={this.state.currentShortcutName}
                    setCurrentShortcutName={this.setCurrentShortcutName}
                    emPlugsV3={this.state.emPlugsV3}
                    emLinkage={this.state.emLinkage}
                    emModelNames={this.state.emModelNames}
                ></YunEmFineTune>
                <PluginTipDia
                    playerData={this.state.playerData}
                    sharpFlatState={this.state.sharpFlatState}
                    vocalsPluginState={this.state.vocalsPluginState}
                    pluginTipDiaState={this.state.pluginTipDiaState}
                ></PluginTipDia>
                <YunPlayer
                    pageset={this.state.pageset}
                    setCurrentPlayer={this.setCurrentPlayer}
                    playerData={this.state.playerData}
                    curSpk={this.state.curSpk}
                    setCurSpk={this.setCurSpk}
                    isSMTC={this.state.isSMTC}
                    setIsSMTC={this.setIsSMTC}
                    clearAiEm={this.clearAiEm}
                ></YunPlayer>
                {/* 消人声 / 升降调：按播放器能力表决定显示控件、提示文字还是「切换伴奏助手」 */}
                {!isAccHelper && this.renderPlayerFeatureRows()}
                <AccHelper 
                    AccHelperValue={this.state.AccHelperValue}
                    isAccHelper={isAccHelper}
                ></AccHelper>
                <YunFooter
                    productInfo={this.state.productInfo}
                    setEnableAutotune={this.setEnableAutotune}
                    promoteUrl={this.state.promoteUrl}
                    pageset={this.state.pageset}
                    handlePageset={this.handlePageset}
                    reloadLocalCnf={this.reloadLocalCnf}
                    restoreServerDefaults={this.restoreServerDefaults}
                    vipInfo={this.state.vipInfo}
                    showmenu={this.state.showmenu}
                    setshowmenu={this.setshowmenu}
                    AccModel={this.state.AccModel}
                    setAccModel={this.setAccModel}
                ></YunFooter>
                <MsgBox
                    onConfirm={this.handleToLogin}
                    show={this.state.msgBoxOption.show}
                    msg={this.state.msgBoxOption.msg}
                ></MsgBox>
            </div>
        );
    }
}

export default App;
